import React, { useState, useMemo, useCallback } from "react";
import { Input } from "../../ui/Input";
import { SelectRegulatoryBody } from "../../selectors/regulatoryBody/selectRegulatoryBody";
import { SelectCountry } from "../../selectors/country/selectCountry";
import { SelectCompanyType } from "../../selectors/companyType/selectCompanyType";
import { SelectExchanges } from "../../selectors/exchanges/selectExchanges";
import useDeligenceStatus from "../../../hooks/useDeligenceStatus";
import { diligenceObservable } from "../../../observers/deligenceObservable";
import { CountryRiskPopup } from "../../popups/countryRiskPopup";
import { useLocation } from "react-router-dom";
import { AlreadyEnhancedPopup } from "../../popups/alreadyEnhancedPopup";
import { RadioGroup } from "../../ui/RadioGroup";
import { yesNoOption } from "../../options/options";
export const StockExchangeForm = React.memo(({ renderBy, index, formData, onChange, isReadOnly, isReport }) => {

    const { getDeligenceStatusByCountry } = useDeligenceStatus();
    const ownerId = useMemo(() => { return renderBy + index.toString() + "StockExchange" }, [index, renderBy]);
    const [showPopup, setShowPopup] = useState(false);

    const handleCountryChange = useCallback(async (event) => {
        diligenceObservable.remove(ownerId);
        const selectedCountry = event.target.value;
        const name = event.target.name;
        if (selectedCountry !== "None") {
            const response = await getDeligenceStatusByCountry(selectedCountry);
            if (response) {
                const hasEnhanced = response.some((item) => item.Diligence.toLowerCase() === "enhanced");
                if (hasEnhanced) {
                    setShowPopup(true);
                }
            }
        }
        let privateEvent = { target: { name: name, value: selectedCountry } };
        onChange(privateEvent);
    }, [getDeligenceStatusByCountry, onChange, ownerId]);
const location = useLocation();
    
    const isManagementStructurePage = location.pathname.includes("management-structure");
    const labelText = isManagementStructurePage
        ? "Is this manager entity regulated by a recognised regulatory body?"
        : "Is this UBO entity regulated by a recognised regulatory body?";

    return (
        <>
            <Input
                label={"Company Name"}
                name={"uboEntityName"}
                disabled={isReadOnly}
                placeholder={"Name of Company"}
                value={formData.uboEntityName}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <SelectCountry
                label={"Country of Incorporation"}
                required={true}
                name={"uboCountry"}
                disabled={isReadOnly}
                value={formData.uboCountry}
                onChange={(e) => { handleCountryChange(e) }}
                isReport={isReport}
            />


{/* 
            <SelectCompanyType
                label={"Company Type"}
                name={"uboEntityType"}
                value={formData.uboEntityType}
                onChange={onChange}
                disabled={isReadOnly}
                country={formData.uboCountry}
                isReport={isReport}
            /> */}
 <Input 
                label={"Company Registration Number"}
                name={"uboCompanyRegistrationNumber"}
                isReport={isReport}
                placeholder={"Company Registration Number"}
                disabled={isReadOnly}
                value={formData.uboCompanyRegistrationNumber}
                onChange={onChange}
                required
            />

            {/* The address used to be stored under uboRegistrationNumber, which is the
                partnership form's registration-number key — validation then asked for a
                "Registration Number" no one could satisfy. Reads fall back to the old key
                so requests saved before the rename still show their address. */}
            <Input
                label={"Registered Office Address"}
                name={"uboRegisteredOfficeAddress"}
                placeholder={"Registered Office Address"}
                disabled={isReadOnly}
                value={formData.uboRegisteredOfficeAddress ?? formData.uboRegistrationNumber ?? ""}
                onChange={onChange}
                isReport={isReport}
                required
            />
<RadioGroup
  label={"Is Entity listed on the Register of Overseas Entities?"}
  disabled={isReadOnly}
  isReport={isReport}
  name={"uboOverseasEntities"}
  value={formData.uboOverseasEntities}
  onChange={onChange}
  options={yesNoOption}
/>
{formData.uboOverseasEntities === "Yes" && (
 <Input 
                label={"Registered Overseas Entities Number"}
                name={"uboOverseasEntitiesNumber"}
                isReport={isReport}
                placeholder={"Registered Overseas Entities Number"}
                disabled={isReadOnly}
                value={formData.uboOverseasEntitiesNumber}
                onChange={onChange}
            />
)
}
<RadioGroup
  label={labelText}
  disabled={isReadOnly}
  isReport={isReport}
  name={"uboRegulatory"}
  value={formData.uboRegulatory}
  onChange={onChange}
  options={yesNoOption}
/>

{formData.uboRegulatory === "Yes" && (
    <>
  <SelectRegulatoryBody 
    label="Select Regulatory Body"
    isReport={isReport}
    name={"uboRegulatoryBody"}
    value={formData.uboRegulatoryBody}
    onChange={onChange}
    disabled={isReadOnly}
    country={formData.uboCountry}
  />
  <Input 
                label={"Enter Regulatory Reference Number"}
                name={"uboRegulatoryReferenceNumber"}
                isReport={isReport}
                placeholder={"Enter Regulatory Reference Number"}
                disabled={isReadOnly}
                value={formData.uboRegulatoryReferenceNumber}
                onChange={onChange}
            />
            </>
)}
<RadioGroup
  label={"Is Entity listed on a recognised exchange?"}
  disabled={isReadOnly}
  isReport={isReport}
  name={"uboRecognisedExchange"}
  value={formData.uboRecognisedExchange}
  onChange={onChange}
  options={yesNoOption}
/>
{formData.uboRecognisedExchange === "Yes" && (
    <SelectExchanges
                    label={"Select the recognised exchange"}
                    name={"uboRecognisedExchangeBodies"}
                    value={formData.uboRecognisedExchangeBodies}
                    onChange={onChange}
                    disabled={isReadOnly}
                    country={formData.uboCountry}
                    isReport={isReport}
                />
)

}
            {showPopup && diligenceObservable.isEnhanced() === false && <CountryRiskPopup ownerId={ownerId} openPopup={true} />}
            {/* {showPopup && diligenceObservable.isEnhanced() === true && <AlreadyEnhancedPopup openPopup={true}/>} */}
        </>
    );

});